import '@ifca-root/react-component/src/assets/styles/components/totalAmountFooter.scss'
import theme from '@ifca-root/react-component/src/assets/theme'
import { useMediaQuery } from '@material-ui/core'
import AppContext from 'containers/App/Store/AppContext'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { useContext } from 'react'
import { useHistory } from 'react-router'

export interface TotalAmountFooterProps {
  dialogPopUp?: any
  dialogPopUp2?: any
  totalCost?: any
  docAmt?: any
  totalTaxAmt?: any
  debitAmt?: any
  creditAmt?: any
  icSelected?: any
  label1?: string
  label2?: string
  outstandingAmt?: any
  singleLabel?: boolean
  singleFooter?: boolean
  rightLabel?: any
  multiLabel?: boolean
  multiFooter?: boolean
  sharedFooter?: any
  isHavePath?: any
  path?: any
  detail?: boolean
  taxInfo?: boolean
  taxInfoDetail?: boolean
  taxInfoDetailWithRecord?: boolean
  isDetail?: boolean
  balanceInfo?: boolean
  balanceAmt?: any
  TotalAllocationAmt?: any
  debitCreditInfo?: boolean
  recordSelected?: boolean
  countRecord?: any
  totalRecord?: any
}

export const TotalAmountFooter = (props: TotalAmountFooterProps) => {
  let history = useHistory()
  const {
    isDetail = false,
    totalCost,
    docAmt,
    totalTaxAmt,
    debitAmt,
    creditAmt,
    icSelected,
    detail,
    taxInfo,
    taxInfoDetail,
    taxInfoDetailWithRecord,
    balanceInfo,
    balanceAmt,
    TotalAllocationAmt,
    debitCreditInfo,
    recordSelected,
    countRecord,
    totalRecord,
  } = props

  const { globalState, dispatch }: any = useContext(AppContext as any)
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  return (
    <div
      className={detail ? 'totalAmountFooterDetail' : 'totalAmountFooter'}
      style={{
        width:
          isDesktop && globalState.drawerOpen
            ? 'calc(100% - 288px)'
            : !isDesktop
            ? '100%'
            : 'calc(100% - 48px)',
        marginLeft:
          isDesktop && globalState.drawerOpen
            ? '264px'
            : !isDesktop
            ? '0px'
            : '24px',
        bottom: isDetail ? '-52px' : '0px',
      }}
    >
      {taxInfo ? (
        <>
          <span
            className="xxTitle flex-space"
            style={{
              fontWeight: 500,
              marginLeft: '17px',
              color: 'white',
              fontSize: '10.5px',
              height: '9px',
              marginTop: '7px',
            }}
          >
            Tax:
            {amtStr(totalTaxAmt)}
          </span>
          <span
            style={{
              fontWeight: 500,
              height: '9px',
              marginLeft: '10px',
              color: 'white',
              float: 'right',
              marginTop: '7px',
              fontSize: '10.5px',
              marginRight: '43px',
            }}
          >
            Total:
            <span style={{ marginLeft: '3px' }} />
            {amtStr(docAmt)}
          </span>
        </>
      ) : debitCreditInfo ? (
        <>
          <span
            style={{
              fontSize: '10.5px',
              fontWeight: 500,
              height: '9px',
              marginLeft: '10px',
              marginRight: '43px',
              color: 'white',
              float: 'right',
              marginTop: '7px',
            }}
          >
            CR:
            <span style={{ marginLeft: '3px' }} />
            {creditAmt}
          </span>
          <span
            style={{
              fontSize: '10.5px',
              fontWeight: 500,
              height: '9px',
              marginLeft: '10px',
              marginRight: '20px',
              color: 'white',
              float: 'right',
              marginTop: '7px',
            }}
          >
            DR:
            <span style={{ marginLeft: '3px' }} />
            {debitAmt}
          </span>
        </>
      ) : taxInfoDetail ? (
        <>
          <span
            className="xxTitle flex-space"
            style={{
              fontWeight: 500,
              marginLeft: '17px',
              color: 'white',
              fontSize: '10.5px',
              height: '9px',
              marginTop: '7px',
            }}
          >
            Tax:
            <span style={{ marginLeft: '3px' }} />
            {amtStr(totalTaxAmt)}
          </span>
          <span
            style={{
              fontWeight: 500,
              height: '9px',
              marginLeft: '10px',
              color: 'white',
              float: 'right',
              marginTop: '7px',
              fontSize: '10.5px',
              marginRight: '20px',
            }}
          >
            Total:
            <span style={{ marginLeft: '3px' }} />
            {amtStr(docAmt)}
          </span>
        </>
      ) : taxInfoDetailWithRecord ? (
        <>
          {countRecord && countRecord >= 0 ? (
            <span
              className="xxTitle flex-space"
              style={{
                fontWeight: 500,
                marginLeft: '10px',
                color: 'white',
                float: 'left',
                marginTop: '7px',
                fontSize: '10.5px',
                marginRight: '20px',
              }}
            >
              No. of records:
              <span style={{ marginLeft: '3px' }} />
              {countRecord ?? 0}
            </span>
          ) : null}
          <span
            className="xxTitle flex-space"
            style={{
              fontWeight: 500,
              marginLeft: '10px',
              color: 'white',
              float: 'right',
              marginTop: '7px',
              fontSize: '10.5px',
              marginRight: '20px',
            }}
          >
            Tax:
            <span style={{ marginLeft: '3px' }} />
            {amtStr(totalTaxAmt)}
          </span>
          <span
            className="xxTitle flex-space"
            style={{
              fontWeight: 500,
              marginLeft: '10px',
              color: 'white',
              float: 'right',
              marginTop: '7px',
              fontSize: '10.5px',
              marginRight: '20px',
            }}
          >
            Total:
            <span style={{ marginLeft: '3px' }} />
            {amtStr(docAmt)}
          </span>
        </>
      ) : balanceInfo ? (
        <>
          <span
            className="xxTitle flex-space"
            style={{
              fontWeight: 500,
              marginLeft: '17px',
              color: 'white',
              fontSize: '10.5px',
              height: '9px',
              marginTop: '7px',
            }}
          >
            Balance:
            <span style={{ marginLeft: '3px' }} />
            {amtStr(balanceAmt)}
          </span>
          <span
            style={{
              fontWeight: 500,
              height: '9px',
              marginLeft: '10px',
              color: 'white',
              float: 'right',
              marginTop: '7px',
              fontSize: '10.5px',
              marginRight: '20px',
            }}
          >
            Total:
            <span style={{ marginLeft: '3px' }} />
            {amtStr(TotalAllocationAmt)}
          </span>
        </>
      ) : recordSelected ? (
        <>
          <span
            className="xxTitle flex-space"
            style={{
              fontWeight: 500,
              marginLeft: '17px',
              color: 'white',
              fontSize: '10.5px',
              height: '9px',
              marginTop: '7px',
            }}
          >
            No. of Records:
            <span style={{ marginLeft: '3px' }} />
            {` ${countRecord}/${totalRecord}`}
          </span>
          <span
            style={{
              fontWeight: 500,
              height: '9px',
              marginLeft: '10px',
              color: 'white',
              float: 'right',
              marginTop: '7px',
              fontSize: '10.5px',
              marginRight: '20px',
            }}
          >
            Total:
            <span style={{ marginLeft: '3px' }} />
            {amtStr(docAmt)}
          </span>
        </>
      ) : icSelected ? (
        <>
          <span
            style={{
              fontWeight: 500,
              height: '9px',
              marginLeft: '10px',
              color: 'white',
              float: 'right',
              marginTop: '7px',
              fontSize: '10.5px',
              marginRight: '20px',
            }}
          >
            Total:
            <span style={{ marginLeft: '3px' }} />
            {amtStr(totalCost)}
          </span>
        </>
      ) : (
        <>
          <span
            style={{
              fontWeight: 500,
              height: '9px',
              marginLeft: '10px',
              color: 'white',
              float: 'right',
              marginTop: '7px',
              fontSize: '10.5px',
              marginRight: '20px',
            }}
          >
            Total:
            <span style={{ marginLeft: '3px' }} />
            {amtStr(docAmt)}
          </span>
        </>
      )}
    </div>
  )
}
